import React from "react";
import SelectableDiv from "../../SelectableDiv";
import PeriodFilterSubPeriod from "./periodfiltersubperiod";
import type moment from "moment";
import Collapse from "@kunukn/react-collapse";

interface Props {
  value: server.dto.PeriodFilterOptions
  onChange: (newValue: server.dto.PeriodFilterOptions, periodStart: moment.Moment, periodEnd: moment.Moment, closeFilter: boolean) => void
  onQuickSelect: (newValue: server.dto.PeriodFilterOptions) => void
  initialStart: moment.Moment
  initialEnd: moment.Moment
  autoFocus?: boolean
}

interface ISelection {
  period: server.dto.PeriodFilterOptions
  formatted: string
}

const QuickSelectPeriods: ISelection[] = [
  { period: "currentYear", formatted: RESX.DateTime.CurrentYear },
  { period: "currentQuarter", formatted: RESX.DateTime.CurrentQuarter },
  { period: "currentMonth", formatted: RESX.DateTime.CurrentMonth },
  { period: "currentWeek", formatted: RESX.DateTime.CurrentWeek },
  { period: "fromToday", formatted: RESX.DateTime.FromToday }
];

const Periods: ISelection[] = [
  { period: "perYear", formatted: RESX.DateTime.PerYear },
  { period: "perQuarter", formatted: RESX.DateTime.PerQuarter },
  { period: "perMonth", formatted: RESX.DateTime.PerMonth },
  { period: "perWeek", formatted: RESX.DateTime.PerWeek },
  { period: "perDay", formatted: RESX.DateTime.PerDay },
  { period: "from", formatted: RESX.DateTime.From },
  { period: "untilAndIncluding", formatted: RESX.DateTime.UntilAndIncluding },
  { period: "fromUntilAndIncluding", formatted: RESX.DateTime.FromUntilAndIncluding }
];

const PeriodSelect = (props: Props) => {
  const [period, setPeriod] = React.useState<server.dto.PeriodFilterOptions>(props.value);

  const onQuickSelect = (selectedValue: server.dto.PeriodFilterOptions) => {
    props.onQuickSelect(selectedValue);
  };

  const onChange = (selectedValue: server.dto.PeriodFilterOptions) => {
    const isUnselectingCurrentValue = period === selectedValue;
    if (isUnselectingCurrentValue) {
      setPeriod("unknown");
      props.onChange("unknown", undefined, undefined, true);
    } else {
      setPeriod(selectedValue);
      props.onChange(selectedValue, props.initialStart, props.initialEnd, false);
    }
  };

  return <>
    {QuickSelectPeriods.map((periodOption, idx) => (
      <React.Fragment key={periodOption.period}>
        <SelectableDiv
          group="periodFilter"
          selected={period === periodOption.period}
          value={periodOption.period}
          onClick={onQuickSelect}
          autoFocus={idx === 0 && props.autoFocus}
        >
          {periodOption.formatted}
        </SelectableDiv>
      </React.Fragment>
    ))}
    <div className="margin-bottom" />
    {Periods.map((periodOption) => {
      const isSubFilterVisible = periodOption.period === period;

      return <React.Fragment key={periodOption.period}>
        <SelectableDiv
          group="periodFilter"
          selected={period === periodOption.period}
          value={periodOption.period}
          onClick={onChange}
          autoFocus={false}
        >
          {periodOption.formatted}
        </SelectableDiv>

        <Collapse className={isSubFilterVisible ? "margin-bottom-small" : undefined} isOpen={isSubFilterVisible}>
          {isSubFilterVisible && <>
            <PeriodFilterSubPeriod
              periodFilter={period}
              onChange={(start, end, closeFilter) => { props.onChange(period, start, end, closeFilter); }}
              initialStart={props.initialStart}
              initialEnd={props.initialEnd}
            />
          </>}
        </Collapse>
      </React.Fragment>;
    })}
  </>;
};

export default PeriodSelect;